module.exports = __webpack_public_path__ + "static/media/dart.b85088c3.svg";